/* Zvonec z obvestili o novih dokumentih.
   [PATCH obvestila-dokumenti v1] — glej NACRT_obvestila-novi-dokumenti_v3_20260713.md
   Pika = vnosi.length > 0. Klik na vrstico = SKOK (zamenja podjetje +
   /dokumenti?tip=zavihek). "Videno" oznaci DokumentiPage ob prihodu (Val 3),
   zato se tu NE brise nicesar. */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { useUploadStore } from '../stores/uploadStore';
import { useObvestilaStore, ObvestiloVnos } from '../stores/obvestilaStore';

const TIP_LABEL: Record<string, string> = {
  prejeti_racun: 'račun',
  izdani_racun: 'račun',
  credit_note: 'dobropis',
  avans: 'avans',
  bancni_izpisek: 'izpisek',
  blagajna: 'blagajna',
};

/* slovenska dvojina za "dokument" */
const mnozDok = (n: number) => {
  const m = n % 100;
  return m === 1 ? 'dokument' : m === 2 ? 'dokumenta'
    : m === 3 || m === 4 ? 'dokumenti' : 'dokumentov';
};

const fmtCas = (iso: string) => {
  const d = new Date(iso);
  const p = (x: number) => String(x).padStart(2, '0');
  return p(d.getDate()) + '.' + p(d.getMonth() + 1) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
};

export function ObvestilaZvonec() {
  const vnosi = useObvestilaStore((s) => s.vnosi);
  const nalozi = useObvestilaStore((s) => s.nalozi);
  const setSelectedCompany = useAuthStore((s) => s.setSelectedCompany);
  const uploadVerzija = useUploadStore((s) => s.verzija);
  const [odprt, setOdprt] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  /* mount + menjava rute */
  useEffect(() => { nalozi(); }, [location.pathname]);
  /* lasten uvoz koncan -> takojsnja osvezitev (brez cakanja na poll) */
  useEffect(() => { if (uploadVerzija > 0) nalozi(); }, [uploadVerzija]);
  /* poll 30 s */
  useEffect(() => {
    const t = setInterval(() => { nalozi(); }, 30000);
    return () => clearInterval(t);
  }, []);

  const skok = async (v: ObvestiloVnos) => {
    setOdprt(false);
    try {
      const r = await api.get('/companies/');
      const c = (r.data || []).find((x: any) => x.id === v.company_id);
      if (!c) { toast.error('Ni dostopa do podjetja ' + v.company_name); return; }
      setSelectedCompany(c);
    } catch {
      toast.error('Napaka pri preklopu podjetja');
      return;
    }
    navigate('/dokumenti?tip=' + v.zavihek + '&ts=' + Date.now()); // [PATCH obvestila-dokumenti v1b] vsili spremembo searchParams
  };

  return (
    <div className="relative">
      <button onClick={() => setOdprt((o) => !o)} title="Obvestila o novih dokumentih"
        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400 relative">
        <Bell className="w-5 h-5" />
        {vnosi.length > 0 && (
          <span className="absolute top-1 right-1 w-2 h-2 bg-blue-500 rounded-full"></span>
        )}
      </button>
      {odprt && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOdprt(false)} />
          <div className="absolute right-0 top-11 z-50 w-96 max-h-96 overflow-y-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg">
            <div className="px-4 py-2 text-xs font-semibold uppercase tracking-wide text-gray-400 border-b border-gray-100 dark:border-gray-800">
              Novi dokumenti
            </div>
            {vnosi.length === 0 && (
              <div className="px-4 py-4 text-sm text-gray-400">Ni novih dokumentov</div>
            )}
            {vnosi.map((v) => (
              <button key={v.company_id + '|' + v.zavihek} onClick={() => skok(v)}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 border-b border-gray-100 dark:border-gray-800 last:border-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium text-sm text-gray-900 dark:text-white truncate">{v.company_name}</span>
                  <span className="text-xs text-gray-400 shrink-0">{fmtCas(v.zadnji_ob)}</span>
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  {v.zavihek_label} · {v.st_dokumentov} {mnozDok(v.st_dokumentov)}
                </div>
                {Object.keys(v.razclenitev || {}).length > 1 && (
                  <div className="text-xs text-gray-400 mt-0.5">
                    {Object.entries(v.razclenitev).map(([k, n]) => n + '\u00d7 ' + (TIP_LABEL[k] || k)).join(' \u00b7 ')}
                  </div>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
